import { register } from '!/repository'
import { createEvent } from 'effector'
import * as pinLockFeature from '~/features/pin-lock'

export const init = createEvent()

register(
  pinLockFeature.$isSettingsEnabled,
  '$settings/root/isPinLockInSettingsEnabled'
)
